import { useForm, DefaultValues } from 'react-hook-form';
import type { BotCreate, BotUpdate } from '../types/bot.types';
import { useCallback } from 'react';

export interface UseBotFormProps {
  defaultValues?: DefaultValues<BotCreate | BotUpdate>;
  onSubmit: (data: BotCreate | BotUpdate) => void;
}

export const useBotForm = ({ defaultValues, onSubmit }: UseBotFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
    trigger,
    watch,
  } = useForm<BotCreate | BotUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      jobId: undefined,
      isVideoRecEnable: false,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: BotCreate | BotUpdate) => {
      onSubmit(data);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
    trigger,
    watch,
  };
};
